import validation from '@/mixins/validation'
import { mapActions, mapGetters } from 'vuex'
import { snakeCase } from 'lodash'

export default {
  name: 'setting-education-categories-translations-item',
  props: {
    locale: {}
  },
  mixin: [validation],
  data () {
    return {
      valid: false,
      payload: {
        locale: this.locale,
        name: '',
        description: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      categoryItem: 'newsCategories/currentItem',
      isTranslationLoading: 'newsCategories/isTranslationLoading'
    }),
    currentItem () {
      return this.categoryItem.translations.data.find(e => e.locale === this.locale)
    }
  },
  created () {
    if (this.currentItem) {
      Object.assign(this.payload, this.currentItem)
    }
  },
  methods: {
    ...mapActions({
      update: 'newsCategories/UPDATE_TRANSLATION'
    }),
    createRequestPayload () {
      const formData = new FormData()

      for (const i in this.payload) {
        formData.append(snakeCase(i), this.payload[i] || '')
      }
      if (this.currentItem && this.currentItem.hasOwnProperty('id')) {
        formData.append('_method', 'patch')
        formData.append('id', this.currentItem.id)
      }
      formData.append('category_id', this.categoryItem.id)
      return formData
    },
    submit () {
      this.$refs.form.validate()
      if (this.valid) {
        this.update(this.createRequestPayload()).then(() => {
          this.$toasted.success(this.$t('success_updated'))
        })
      }
    }
  }
}
